
    export const uniqueSort = (arr = []) => {
        const map = {};
        const res = [];
        for (let i = 0; i < arr.length; i++) {
        if (!map[arr[i]]) {
            map[arr[i]] = true;
            res.push(arr[i]);
        };
        };
        return res.sort((a, b) => a - b);
    };

